import { render, staticRenderFns } from "./insurance_detail_m.vue?vue&type=template&id=4c7cf90f&scoped=true&"
import script from "./insurance_detail_m.vue?vue&type=script&lang=js&"
export * from "./insurance_detail_m.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7cf90f",
  null
  
)

export default component.exports